// extracted by mini-css-extract-plugin
module.exports = {"price":"styles_price__ImjFh","total":"styles_total__OcDiC","caption":"styles_caption__HHead","sale":"styles_sale__RLa06","partnersWrapper":"styles_partnersWrapper__pMPxP"};